"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Parse the given JSON and return the result if successful, otherwise undefined.
 *
 * @Param {string} json = The JSON string to parse.
 *
 * @Example
 *
 *   parseJson('{}')
 *   //=> {}
 *
 *   parseJson('{')
 *   //=> undefined
 */
function parseJson(json) {
    try {
        return JSON.parse(json);
    }
    catch (_a) {
        return undefined;
    }
}
exports.parseJson = parseJson;
//# sourceMappingURL=parse-json.js.map